import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Calculator from "./Calculator";
import React, {useRef, useState} from "react";

const CalculatorModal = ({open, position, onClose, handleSubmit}) => {
    const [input, setInput] = useState('');
    const inputRef = useRef(null)

    const calculate = () => {
        let newInput
        try {
            if (input === "") return undefined
            newInput = eval(input).toString();
            if (isFinite(newInput)) {
                setInput(newInput)
                return newInput
            } else {
                throw new Error()
            }
        } catch (error) {
            newInput = "Error"
            setInput(newInput)
        }
        inputRef.current.focus()
    };

    const submit = () => {
        handleSubmit(calculate(), close)
    }
    const close = () => {
        onClose()
        setInput("")
    }
    return (
        <Dialog open={open} onClose={close}
                PaperProps={{
                    sx: {
                        position: "fixed",
                        top: position.y,
                        left: position.x,
                    }
                }}>
            <DialogContent sx={{p: 0}}>
                <Calculator input={input} setInput={setInput} calculate={calculate} submit={submit}
                            inputRef={inputRef}/>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
            </DialogActions>
        </Dialog>
    );
}
export default CalculatorModal